import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

/**
 * Custom alert modal
 * You can specify three button types:
 * - Nondestructive
 * - Destructive
 * - Neutral
 */
export const AlertModal = (props: {
  id: string;
  title: string;
  content: string | React.ReactElement;
  opened: boolean;
  actions: Array<{
    label: string;
    handleClick: () => void;
    type: 'destructive' | 'nondestructive' | 'neutral';
  }>;
  handleClose: () => void;
  preventCloseClick?: boolean;
}) => {
  // Get the button color from the action type
  const getColorFromActionType = (type: 'destructive' | 'nondestructive' | 'neutral') => {
    switch (type) {
      case 'destructive':
        return 'error';
      case 'nondestructive':
        return 'primary';
      case 'neutral':
        return 'inherit';
      default:
        return 'primary';
    }
  };

  return (
    <Dialog
      id={props.id}
      open={props.opened}
      onClose={props.preventCloseClick ? () => {} : props.handleClose}
    >
      <DialogTitle>{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{props.content}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{flexWrap: 'wrap'}}>
        {props.actions.map((action) => (
          <Button
            key={`alert-modal-button-${action.type}-${action.label}`}
            color={getColorFromActionType(action.type)}
            onClick={action.handleClick}
          >
            {action.label}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
};
